import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { Sparkles, CheckCircle2, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-20 md:pt-20 md:pb-28 overflow-hidden bg-navy" data-id="element-61">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-62"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-63"></div>
      <div className="absolute top-40 left-10 text-gold/[0.06] text-9xl font-serif select-none pointer-events-none" data-id="element-64">
        ♪
      </div>
      <div className="absolute bottom-20 right-10 text-gold/[0.06] text-8xl font-serif select-none pointer-events-none" data-id="element-65">
        ♫
      </div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-66">
        <div className="flex flex-col items-center text-center" data-id="element-67">
          {/* Product Badge */}
          <FadeIn data-id="element-68">
            <div className="inline-flex items-center gap-2 bg-gold/15 border border-gold/30 text-gold px-5 py-2 rounded-full text-sm md:text-base font-semibold mb-8 backdrop-blur-sm" data-id="element-69">
              <Sparkles className="w-4 h-4" data-id="element-70" />
              Piano Fácil PRO · Método Completo
            </div>
          </FadeIn>

          {/* Headline */}
          <FadeIn delay={0.1} data-id="element-71">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-beige mb-6 leading-[1.05] max-w-4xl mx-auto tracking-tight" data-id="element-72">
              Todo tu año de <span className="text-gold" data-id="element-73">piano</span>{' '}
              <span className="text-gold underline decoration-gold/40 underline-offset-4 decoration-[3px]" data-id="element-74">
                resuelto
              </span>
            </h1>
          </FadeIn>

          {/* Mockup */}
          <FadeIn delay={0.3} className="w-full max-w-md mx-auto mb-6 mt-4" data-id="element-75">
            <div className="relative" data-id="element-76">
              <div className="absolute inset-0 bg-gold/30 blur-3xl rounded-full transform scale-90" data-id="element-77"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cW96ahCdMJqK6kMQRFBrK9/Untitled_design.png" alt="Piano Fácil PRO" className="relative z-10 w-[75%] h-auto drop-shadow-[0_25px_50px_rgba(0,0,0,0.5)] mx-auto" data-id="element-78" />
            </div>
          </FadeIn>

          {/* Subtitle */}
          <FadeIn delay={0.4} data-id="element-79">
            <p className="text-xl md:text-2xl text-beige/90 mb-3 max-w-2xl mx-auto font-medium" data-id="element-80">
              Aprendé a tocar piano{' '}
              <span className="text-gold font-semibold" data-id="element-81">
                sin partituras ni teoría
              </span>
            </p>
            <p className="text-base md:text-lg text-beige/60 italic mb-10 max-w-2xl mx-auto" data-id="element-82">
              Aunque siempre pensaste que era tarde para aprender…
            </p>
          </FadeIn>

          {/* Tomos & Bonos tagline */}
          <FadeIn delay={0.45} data-id="element-83">
            <p className="text-lg md:text-xl font-bold text-beige mb-5 text-center" data-id="element-84">
              <span className="text-gold" data-id="element-85">8 Tomos</span>
              <span className="text-beige/40 mx-2" data-id="element-86">·</span>
              <span className="text-gold" data-id="element-87">3 Bonos</span>
              <span className="text-beige/40 mx-2" data-id="element-88">·</span>
              <span data-id="element-89">Listo para usar</span>
            </p>
          </FadeIn>

          {/* Quick benefits */}
          <FadeIn delay={0.5} data-id="element-90">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-6 text-sm md:text-base" data-id="element-91">
              <div className="flex items-center gap-2 text-beige/90" data-id="element-92">
                <CheckCircle2 className="w-5 h-5 text-gold" data-id="element-93" />
                <span data-id="element-94">PDF Digital</span>
              </div>
              <div className="flex items-center gap-2 text-beige/90" data-id="element-95">
                <CheckCircle2 className="w-5 h-5 text-gold" data-id="element-96" />
                <span data-id="element-97">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2 text-beige/90" data-id="element-98">
                <CheckCircle2 className="w-5 h-5 text-gold" data-id="element-99" />
                <span data-id="element-100">Para Principiantes</span>
              </div>
            </div>
          </FadeIn>

          {/* CTA */}
          <FadeIn delay={0.6} className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-101">
            <CTAButton fullWidth className="mb-4" data-id="element-102">
              QUIERO TOCAR MI PRIMERA CANCIÓN
            </CTAButton>
            <p className="text-sm font-medium text-beige/60 flex items-center gap-2 mb-6" data-id="element-103">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-104"></span>
              Acceso inmediato – empezás hoy mismo
            </p>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-beige/60" data-id="element-105">
              <div className="flex items-center gap-1.5" data-id="element-106">
                <Shield className="w-4 h-4" data-id="element-107" />
                <span data-id="element-108">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-109">
                <Lock className="w-4 h-4" data-id="element-110" />
                <span data-id="element-111">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-112">
                <CreditCard className="w-4 h-4" data-id="element-113" />
                <span data-id="element-114">Astro Pay | Tarjeta</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}